var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarehouse = function SvgWarehouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.492 5.525a1.25 1.25 0 0 1 1.016 0l15 6.666c.451.201.742.649.742 1.143V35a1.25 1.25 0 1 1-2.5 0V14.146L20 8.035 6.25 14.146V35a1.25 1.25 0 1 1-2.5 0V13.334c0-.494.29-.942.742-1.143z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.917 20.417V20A2.917 2.917 0 0 0 20 17.083h-3.333A2.917 2.917 0 0 0 13.75 20v3.75h-2.083c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16.666c.69 0 1.25-.56 1.25-1.25V21.667c0-.69-.56-1.25-1.25-1.25zm0 2.5V33.75h4.166V22.917zm-2.5 10.833v-7.5h-7.5v7.5zm0-10V20a.417.417 0 0 0-.417-.417h-3.333a.417.417 0 0 0-.417.417v3.75z",
    clipRule: "evenodd"
  })));
};
export default SvgWarehouse;